import { getProductWithVariants, ProductWithVariants } from '@models/product';
import { auslandsKvDamageReportSteps } from './damage-report-steps';
import { defaultContractWidgets } from '@config/default-contract-widgets';
import { AuslandKVWidgetComponent } from '../widgets/ausland-kv-widget/ausland-kv-widget.component';
import { hasTags } from 'app/products/fns';
import { OrderState } from 'app/order/models';

export const reiseAuslandsKrankenversicherung: ProductWithVariants = getProductWithVariants({
    // default = single
    slug: 'reise-auslandskrankenversicherung',
    title: 'Reise-Auslandskrankenversicherung',
    collapsableTitle: 'Reise-Auslands&shy;kranken&shy;versicherung',
    insuranceTypeName: 'AR',
    insuranceTypeId: 2,
    legacy: true,
    portalConfig: {
        damageReportSteps: auslandsKvDamageReportSteps,
        widgets: [...defaultContractWidgets, { component: AuslandKVWidgetComponent }],
    },
    variants: [
        // single premium
        {
            condition: (state: OrderState) => hasTags(state, { single: true, premium: true }),
            overrides: {
                slug: 'reise-auslandskrankenversicherung-premium',
                title: 'Reise-Auslandskrankenversicherung Premium',
                collapsableTitle: 'Reise-Auslands&shy;kranken&shy;versicherung Premium',
                insuranceTypeName: 'AR Premium',
                insuranceTypeId: 35,
            },
        },
        // couples
        {
            condition: (state) => hasTags(state, { couple: true, premium: false }),
            overrides: {
                slug: 'reise-auslandskrankenversicherung-paare',
                title: 'Reise-Auslandskrankenversicherung Paare',
                collapsableTitle: 'Reise-Auslands&shy;kranken&shy;versicherung für Paare',
                insuranceTypeName: 'AKV Paare',
                insuranceTypeId: 26,
            },
        },
        // couples premium
        {
            condition: (state) => hasTags(state, { couple: true, premium: true }),
            overrides: {
                slug: 'reise-auslandskrankenversicherung-paare-premium',
                title: 'Reise-Auslandskrankenversicherung Paare Premium',
                collapsableTitle: 'Reise-Auslands&shy;kranken&shy;versicherung für Paare Premium',
                insuranceTypeName: 'AKV Paare Premium',
                insuranceTypeId: 36,
            },
        },
        // family
        {
            condition: (state) => hasTags(state, { family: true, premium: false }),
            overrides: {
                slug: 'reise-auslandskrankenversicherung-familie',
                title: 'Reise-Auslandskrankenversicherung Familie',
                collapsableTitle: 'Reise-Auslands&shy;kranken&shy;versicherung für Familien',
                insuranceTypeName: 'AKV',
                insuranceTypeId: 25,
            },
        },
        // family premium
        {
            condition: (state) => hasTags(state, { family: true, premium: true }),
            overrides: {
                slug: 'reise-auslandskrankenversicherung-familie-premium',
                title: 'Reise-Auslandskrankenversicherung Familie Premium',
                collapsableTitle: 'Reise-Auslands&shy;kranken&shy;versicherung für Familien Premium',
                insuranceTypeName: 'AKV Familie Premium',
                insuranceTypeId: 37,
            },
        },
    ],
});
